import { Playground } from "docz";
import { Translator } from "../../../../../docz/components";
import React from 'react';
export default {
  Playground,
  Translator,
  React
};